
define('text!modules/targeting/location/templates/grid_subitem.html',[],function () { return '{{#group}}\n<div class="group-name">\n    <span class="group-c">{{group}}</span>\n</div>\n{{/group}}\n{{#list}}\n  {{#isHyperLocal}}\n    {{>geoFenceListItem}}\n  {{/isHyperLocal}}\n  {{^isHyperLocal}}\n    {{>listItem}}\n  {{/isHyperLocal}}\n{{/list}}\n';});

